export default __webpack_public_path__ + "static/media/advicegradissuegfx-01.4c968559.png";